export const curriculumPeriodMode = ["monthly", "yearly"] as const;
export type CurriculumPeriodMode = typeof curriculumPeriodMode[number];

export function isCurriculumPeriodMode(str: string): str is CurriculumPeriodMode {
  return curriculumPeriodMode.some(v => v === str);
}
